/**
 * Created by sagil on 06/10/2016.
 */

import {Pipe, PipeTransform} from "@angular/core";
import {KendoDatetimeLocaleService} from "../services/kendo.datetime.service";

/**
 * **********************************************************************
 * Pipe that handles formatting of dates.
 *
 * Written by: Sagi Levi
 * **********************************************************************
 */
@Pipe({
	name: 'cpDate',
	pure: true
})
export class DatePipe implements PipeTransform {

	constructor(private datetimeFormatService:KendoDatetimeLocaleService) {
	}

	transform(query: Date | string, format?: string, isFriendly?: boolean, dayName?:boolean):any {
		return isFriendly?
			this.datetimeFormatService.friendlyDate(query, format,dayName):
			this.datetimeFormatService.date(query, format);
	}
}
